module.exports = __webpack_public_path__ + "img/bank_03.b22079f2.png";